import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { When } from 'react-if';

import * as ROUTES from '../../../constants/routes';
import { Button } from '../../elements/buttons/Button';
import { Categories, SidekickCategories } from '../../../static/categories';
import './FilterQuestionBar.css';
import Category from '../../elements/Category/Category';
import { Row, Col, Container } from 'react-bootstrap';
import { IS_SIDEKICK_APP } from '../../../constants/projects';

const categoriesKey = IS_SIDEKICK_APP ? Object.keys(SidekickCategories) : Object.keys(Categories);

export const FilterQuestionBar = ({
    isPreview,
    activeSubCategories,
    subCategoriesToggle,
    activeCategory,
    categoryToggle,
}) => {
    const history = useHistory();

    const handleAddPostButtonClick = useCallback(() => {
        history.push(ROUTES.CREATE_POST);
    }, [history]);

    return (
        <div>
            <When condition={isPreview}>
                <div className="filter-question-bar__preview w-100" />
            </When>

            <div className="FilterQuestionBar-Wrapper row justify-content-center">
                <div className="d-flex justify-content-between align-items-center filter-bar w-75">
                    <Row className="w-100">
                        <Col lg={8} className="d-flex align-items-center w-100 p-0">
                            <div className="d-flex w-100">
                                <When condition={categoriesKey}>
                                    {categoriesKey.map(category => (
                                        <Category
                                            key={category.label}
                                            activeCategory={activeCategory}
                                            categoryToggle={categoryToggle}
                                            category={
                                                IS_SIDEKICK_APP
                                                    ? SidekickCategories[category]
                                                    : Categories[category]
                                            }
                                        />
                                    ))}
                                </When>
                            </div>
                        </Col>
                        <Col lg={4} className="p-0">
                            <div className="d-flex justify-content-end filter-question-bar__add-button-container">
                                <span className="category__delimiter">…….</span>
                                <input
                                    type="button"
                                    value={IS_SIDEKICK_APP ? 'Post a project' : 'Post a question +'}
                                    className="filter-question-bar__add-button"
                                    onClick={handleAddPostButtonClick}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

FilterQuestionBar.propTypes = {
    isPreview: PropTypes.bool,
};

FilterQuestionBar.defaultProps = {
    isPreview: false,
};

export default React.memo(FilterQuestionBar);
